export default __webpack_public_path__ + "static/media/question.a8c17804.svg";